import api from './api';

export const feedsApi = {
  async list(page = 1, query = '', signal) {
    const params = new URLSearchParams({ page: String(page), size: '20', locale: 'ko', q: query });
    const response = await api.getPublic(`/feeds?${params}`, { signal, suppressGlobalError: true });
    return { items: response.data.data || [], ...response.data.meta?.pagination };
  },
  async detail(identifier, authenticated, signal) {
    const path = /^\d+$/.test(identifier)
      ? `/feeds/${identifier}`
      : `/feeds/by-slug/${encodeURIComponent(identifier)}`;
    const get = authenticated ? api.getAuth : api.getPublic;
    const response = await get(`${path}?locale=ko`, { signal, suppressGlobalError: true });
    return response.data.data;
  },
  async bookmark(id, saved) {
    if (saved) return api.deleteAuth(`/bookmarks/feed/${id}`);
    return api.postAuth('/bookmarks', { itemType: 'FEED', itemId: id });
  },
};
